module.exports = __webpack_public_path__ + "img/app_passes_screen@3x.97c834fc.png";